function options(data) {
    if (data.options) {
        let markup = ''
        for (let i = 0; i < data.options.length; i++) {
            // prettier-ignore
            markup += `<div class="radio-tag">
                <input type="radio" data-element="input" class="radio-tag__input" id="${data.options[i].id}"
                value="${data.options[i].id}"
                name="filters[${data.handle}]" ${data.options[i].selected ? 'checked' : ''}>
                <label for="${data.options[i].id}" class="radio-tag__label ${data.options[i].selected ? 'checkbox-lozenge__label--active' : ''}">${data.options[i].name}</label>
            </div>`
        }
        return markup
    } else {
        return ''
    }
}

const template = (data) => `
    <div class="u-df u-df-col@medium">
        <div class="radio-tag">
            <input type="radio" data-element="input" checked class="radio-tag__input" id="all+topics"}"
            value=""
            name="filters[${data.handle}]">
            <label for="all+topics" class="radio-tag__label">All Topics</label>
        </div>
        ${options(data)}
    </div`
export default template
